module.exports = __webpack_public_path__ + "static/img/mht.1e79d4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/mht.png
// module id = Ng/F
// module chunks = 53